import { UserOutlined } from '@ant-design/icons'
import { Avatar } from 'antd'
import React from 'react'

import { User } from '../../../../../entities/user/types/user.types'

type ProfileMenuItemProps = {
  user: User | null
}

export const ProfileMenuItem = ({ user }: ProfileMenuItemProps) => {
  return (
    <div className="d-flex align-items-center gap-3 p-2">
      <Avatar
        icon={!user?.avatar && <UserOutlined />}
        size={40}
        src={user?.avatar}
      />
      <div className="d-flex flex-column">
        <div className="fw-medium">{user?.fio}</div>
        <div className="small text-muted">{user?.email}</div>
      </div>
    </div>
  )
}
